<!--
 * @Author: cn1994
 * @Date: 2023-09-07 10:21:10
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-12 14:02:08
 * @Description: file content
-->
<template>
  <div class="ls-mobile-preview-phone-component">
    <div class="top">
      <!-- 机构信息 -->
      <NewInstComponent :instInfo="instInfo" />
      <!-- 导航 -->
      <navComponent :topConfig="topConfig" :role="role" />
    </div>
    <div class="bottom" @mousewheel="handelMousewheel">
      <plateComponent :plateConfig="plateConfig" :role="role"/>
    </div>
  </div>
</template>

<script>
import NewInstComponent from './NewInst.vue'
import navComponent from './nav.vue'
import plateComponent from './plate.vue'

export default {
  components: {
    NewInstComponent,
    navComponent,
    plateComponent
  },
  props: {
    instInfo: {
      type: Object,
    },
    topConfig: {
      type: Array,
      default: []
    },
    leftConfig: {
      type: Array,
      default: []
    },
    role: {
      type: String,
    },
    plateConfig: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return  {

    }
  },
  methods: {
    handelMousewheel(e) {
      let dom = document.querySelector('.bottom')
      let ua = window.navigator.userAgent
      let isMac = ua.includes('OS X')
      if (isMac) {
        if (e.deltaX > 0) {
          // 往左划
          dom.scrollLeft += 20
        } else {
          // 往右划
          dom.scrollLeft -= 20
        }
      } else {
        if (e.deltaY > 0) {
          // 往左划
          dom.scrollLeft += 100
        } else {
          // 往右划
          dom.scrollLeft -= 100
        }
      }

      e.preventDefault()
    }
  }
}
</script>

<style lang="less" scoped>
.ls-mobile-preview-phone-component {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(5px);
  .top {
    height: 80px;
    max-width: 720px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 52px;
  }
  .bottom {
    flex: 1;
    display: flex;
    padding-bottom: 9px;
    overflow-x: scroll;
  }
}
</style>
